import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enJSON from '../../localization/en.json';
import ruJSON from '../../localization/ru.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['ru', 'en'],
    resources: {
      en: { translation: enJSON },
      ru: { translation: ruJSON }
    }
  });

export default i18n;
